import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

export const NewRackForm = ({
  onClose = () => {},
  onCreate = console.log
}: {
  onClose?: () => void,
  onCreate?: (baseName:string, total_units:number, max_power:number, count:number) => void
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [form, setForm] = useState<any>({
    baseName: 'Rack',
    total_units: 45,
    max_power: 0,
    count: 1,
  })

  const onSubmit = async (e:any) => {
    e?.preventDefault();
    setIsLoading(true);
    onCreate(form.baseName, form.total_units, form.max_power, form.count);
    setIsLoading(false);
    onClose();
  }

  return (
  <div className="fixed z-10 inset-0 overflow-y-auto">
    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
        <div className="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div className="z-1 relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
        <div className="flex justify-between">
          <div className="text-lg">Add Racks</div>
          <button onClick={onClose} className="cursor-pointer">
            <AiOutlineClose />
          </button>
        </div>
        <div>
          <form onSubmit={onSubmit}>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Base name for racks
              </label>
              <input
                required
                onChange={(e) => setForm({...form, baseName: e.target.value})}
                className="w-full border border-gray-300 mb-4 rounded-md p-2"
                type="text"
                placeholder="Rack"
                defaultValue={form.baseName}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                How many racks would you like to create?
              </label>
              <input
                required
                onChange={(e) => setForm({...form, count: Number(e.target.value || 1)})}
                className="w-full border border-gray-300 mb-4 rounded-md p-2"
                type="number"
                placeholder="Number of racks"
                defaultValue={form.count}
                min="1"
                max="50"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Total units per rack
              </label>
              <input
                required
                onChange={(e) => setForm({...form, total_units: Number(e.target.value || 0)})}
                className="w-full border border-gray-300 mb-4 rounded-md p-2"
                type="number"
                placeholder="Total units"
                defaultValue={form.total_units}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Max power per rack
              </label>
              <input
                required
                onChange={(e) => setForm({...form, max_power: Number(e.target.value || 0)})}
                className="w-full border border-gray-300 mb-4 rounded-md p-2"
                type="number"
                placeholder="Max power"
                defaultValue={form.max_power}
              />
            </div>
            <div className="mt-4">
              {isLoading ? (<>Creating racks...</>) : 
              (<button 
                type="submit" 
                className="bg-primary hover:bg-primary/90 font-bold py-2 px-4 rounded cursor-pointer"
              >
                Create {form.count} Rack{form.count > 1 ? 's' : ''}
              </button>)}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  );
};
